// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2462 ? "react-monaco-editor" : chunkId) + "." + {"2462":"ae6d46e7","3835":"01b011db","7506":"090830c5"}[chunkId] + ".chunk.css";
};